import { Footer } from "components/Footer/Footer";
import { NavBar } from "components/NavBar/NavBar";
import { useEffect } from "react";
import { JSX } from "react/jsx-runtime";
import { PageWrapper, ContentWrapper } from "styles/layout";
import { PageConfig } from "./PageConfigs";

const DEFAULT_TITLE = "eCircuitMania";
const DEFAULT_DESCRIPTION =
  "Track the latest TrackMania eSports with eCircuitMania. Get real-time rankings, tournament results, statistics, and make predictions.";

interface Props {
  config: PageConfig;
}

export const Page = ({ config }: Props) => {
  const title = config.title ?? DEFAULT_TITLE;
  const description = config.description ?? DEFAULT_DESCRIPTION;

  useEffect(() => {
    document.title = title;
    const metaTag = document.querySelector('meta[name="description"]');
    if (!!metaTag) {
      metaTag.setAttribute("content", description);
    }
  }, [title, description]);

  return config.showNavBarAndFooter
    ? WithNavBarAndFooter(config.page)
    : config.page;
};

const WithNavBarAndFooter = (element: JSX.Element) => {
  return (
    <PageWrapper>
      <NavBar />
      <ContentWrapper>{element}</ContentWrapper>
      <Footer />
    </PageWrapper>
  );
};
